import React from 'react';
import './Courses.scss';

function Courses(props) {
  const details = props.details.map((detail) =>
    <li className="courses__details" key={detail.toString()}>{detail}<br/></li>
  );

  let priceClass = 'courses__price';
  let courseClass = 'courses';
  if (props.important) {
    priceClass += ' courses__price_important';
    courseClass += ' courses_important'
  }

  return (
    <div className={courseClass}>
      <div>
        <h5 className="courses__title">{props.title}<br/>{props.time}</h5>
        <ul>{details}</ul>
      </div>
      <div className="row align-center">
        <div className={priceClass}>{props.price}</div>
      </div>
    </div>
  );
}

export default Courses;



// WEBPACK FOOTER //
// ./src/components/Services/Common/Course/Courses.jsx